import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {AtivitiesService} from '../../+activities/ativities.service';
import {MOMENT_TOKEN} from '../../../shared/shared.module';
import {DialogAcceptTaskComponent} from '../dialog-accept-task/dialog-accept-task.component';
import {TasksService} from '../tasks.service';

@Component({
  selector: 'app-see-tasks',
  templateUrl: './see-tasks.component.html',
  styleUrls: ['./see-tasks.component.scss']
})
export class SeeTasksComponent implements OnInit {
  public tasks: any[] = [];
  public filters: any;
  public tasklist: any[] = [];
  private dateLimit = new Date().getTime() - 7 * 24 * 60 * 60 * 1000;

  constructor(
    private tasksService: TasksService,
    private dialog: MatDialog,
    private activitiesService: AtivitiesService,
    @Inject(MOMENT_TOKEN) public moment
  ) {
  }

  ngOnInit() {
    this.initializeFilters();
    this.tasksService.getUserTasks().then(res => {
      this.tasks = res.data;
      this.updateSearch();
    });
  }

  filterTasks() {
    return this.tasks.filter(task => {
      const date: Date = new Date(task.postDate);

      return date.getTime() > this.dateLimit;
    });
  }

  public updateSearch() {
    if (
      this.filters.action.Active ||
      this.filters.action.Achevee ||
      this.filters.action.Priorite_Elevee ||
      this.filters.action.Priorite_Moyenne ||
      this.filters.action.Priorite_Basse ||
      this.filters.action.TodaysFilter ||
      this.filters.action.Late ||
      (this.filters.chooseDate.begin && this.filters.chooseDate.end)
    ) {
      this.tasklist = this.tasks.filter((res: any) => {
        if (
          this.filters.action.Active &&
          res.workflowInstance.isActive === true
        ) {
          return true;
        } else if (this.filters.action.Achevee) {
          this.tasksService.getUserAchievedTasks().then(res => {
            this.tasklist = res.data;
          });
        } else if (
          this.filters.action.Priorite_Elevee &&
          res.properties.bpm_priority === 1
        ) {
          return true;
        } else if (
          this.filters.action.Priorite_Moyenne &&
          res.properties.bpm_priority === 2
        ) {
          return true;
        } else if (
          this.filters.action.Priorite_Basse &&
          res.properties.bpm_priority === 3
        ) {
          return true;
        } else if (this.filters.action.TodaysFilter) {
          this.tasksService.getUserTodaysTasks().then(res => {
            this.tasklist = res.data;
          });
        } else if (this.filters.action.Late) {
          this.tasksService.getUserLateTasks().then(res => {
            this.tasklist = res.data;
          });
        } else if (
          this.filters.chooseDate.begin &&
          this.filters.chooseDate.end
        ) {
          const begin =
            this.moment(this.filters.chooseDate.begin).format(
              'YYYY-MM-DD[T]HH:mm:ss.SSS'
            ) + '+01:00';
          const end =
            this.moment(this.filters.chooseDate.end).format(
              'YYYY-MM-DD[T]HH:mm:ss.SSS'
            ) + '+01:00';
          this.tasksService.getUserDateTasks(begin, end).then(res => {
            this.tasklist = res.data;
          });
        }
      });
    } else {
      this.tasklist = this.tasks;
    }
  }

  public gettasks() {


    this.activitiesService.getTasks().then((res) => {

      this.tasks = res.data;

    });


  }

  public acceptTask(data: any) {

    const dialogRef = this.dialog.open(DialogAcceptTaskComponent, {
      width: '50%',
      height: '30%',
      data: {
        data: data
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {

      setTimeout(() => {
        if (result) {
          this.gettasks();
        }

      }, 500);
    });
  }

  private initializeFilters() {
    this.filters = {
      action: {
        Active: false,
        Achevee: false,
        Priorite_Elevee: false,
        Priorite_Moyenne: false,
        Priorite_Basse: false,
        TodaysFilter: false,
        Late: false
      },
      chooseDate: {
        begin: null,
        end: null
      }
    };
  }
}
